import { Scene, AbstractMesh, MeshBuilder, Mesh, ArcRotateCamera, ShaderMaterial, Vector3, TransformNode, ShadowGenerator, Texture, PBRMaterial, CubeTexture, PointerEventTypes, Color3, StandardMaterial, SpotLight, PointLight } from '@babylonjs/core';
import { ModelLoader } from '../loader/ModelLoader';
import { BaseStage } from './BaseStage';
import { GlobalObject } from '../utils/GlobalObject';
import { Boardcaster } from './../event/Boadcaster';
import { CrossEvent } from './../event/CrossEvent';
import { Menu } from '../displayObject/UI/Menu';
import { EquipmentGroundMaterial } from '../materials/equipCircle/EquipmentGroundMaterial';

export class Equipment extends BaseStage {
    protected scene: Scene;
    private equipmentMesh?: AbstractMesh | null;
    private groundMesh?: Mesh;
    private source?: any;
    private spotLight?: SpotLight;
    private pointLight?: PointLight;
    private shadowGenerator?: ShadowGenerator;
    private menu: Menu;
    constructor(scene: Scene) {
        super(scene);
        this.scene = scene;
        this.source = GlobalObject.getInstance().main.source.equipment;
        this.menu = Menu.getInstance();
        this.addGround();
        this.init();
    }
    private init() {
        console.log('Equipment init')
        Boardcaster.getInstance().setStage(this);
        GlobalObject.getInstance().main.skybox?.setIndoorSkybox(1.5);

        this.scene.environmentIntensity = 0;
        const camera = (GlobalObject.getInstance().main.camera as ArcRotateCamera);
        camera.radius = 12;
        camera.upperRadiusLimit = 25;
        camera.minZ = 0.1;
        camera.maxZ = 200;
        camera.fov = 0.3 * Math.PI;
        camera.alpha = -1.57;
        camera.beta = 1.2;
        const player = GlobalObject.getInstance().main.player;
        if (player && player.player) {
            player.locked = true;
            player.player.position.set(0, 0, 0);
        }

        this.menu.changeBackBtn(true);
    }
    public async open(id?: string, path?: string, from?: string) {
        let msg = { type: "openEquipment", data: { name: id, macno: id } }
        Boardcaster.getInstance().send(msg);
        GlobalObject.getInstance().setStageName((from ? from : "") + "Equipment");
        if (id) {
            this.init();
            let loader = ModelLoader.instance;
            this.equipmentMesh = await loader.getModel('resources/models/equipment/' + path + id + '.glb', 1, 1);
            console.log(this.equipmentMesh);
            (this.equipmentMesh as TransformNode).getChildMeshes().forEach((c) => {
                this.shadowGenerator?.addShadowCaster(c);
                c.receiveShadows = true;
            });
            let m = this.equipmentMesh?.getChildMeshes()[0] as Mesh;
            if (m) {
                let pos = m.getAbsolutePosition().clone();
                //let dir = Vector3.TransformCoordinates(m.forward.clone(), m.worldMatrixFromCache.clone());
                this.pointLight?.position.set(pos.x, 5, pos.z);
                this.groundMesh?.position.set(pos.x, -0.01, pos.z);
                const player = GlobalObject.getInstance().main.player;
                if (player && player.player) {
                    let target = new Vector3(pos.x, 0, pos.z);
                    player.player.position = target;
                }
            }
        }
    }
    private addGround() {
        this.pointLight = new PointLight("point_light", new Vector3(0, 5, 0), this.scene);
        this.pointLight.intensity = 30;
        this.shadowGenerator = new ShadowGenerator(1024, this.pointLight);


        this.groundMesh = MeshBuilder.CreateGround("equipment_ground", { width: 50, height: 50, subdivisions: 10 }, this.scene);
        this.groundMesh.receiveShadows = true;

        let mat = new StandardMaterial("equipment_ground_mat", this.scene);
        const t = new Texture(this.source.groudImg, this.scene);
        t.uScale = t.vScale = 15;
        const opacityTex = new Texture(this.source.groudAlphaImg, this.scene);

        mat.diffuseTexture = t;
        mat.transparencyMode = 2;
        mat.opacityTexture = opacityTex;
        mat.specularColor = new Color3(0, 0, 0);

        this.groundMesh.material = mat;
        this.groundMesh.position.y = -0.01;
    }
    //  ----------------------------------------- default -----------------------------------------------
    public onViewAngleChanged(data: any, locked: boolean = false) { }
    public onCamChanged(data: any) {
        const camShowed = typeof (data) === 'boolean' ? data : true;
        GlobalObject.getInstance().setCamShowed(camShowed);
    }
    public onWorkshopChanged(idx: number) {
        // idx 0-5--> 0首页 1静子 2转子 3联合 4喷涂 5配送 6总装
        //console.log("data is: " + idx);
        let data = "qwq2x";
        if (idx - 1 >= 0) {
            data = "ohp_" + (idx - 1);
        }
        const emitter = CrossEvent.getInstance().getEmitter();
        emitter.emit(CrossEvent.getInstance().STAGE_CHANGED, {
            data: data,
            descript: "切换场景",
            from: "AJingziStage",
            eventType: "CrossEvent",
        });

    }
    public back() {
        let obj = {
            "A": 1,
            "B": 2,
            "C": 3,
            "D": 4,
            "E": 5,
            "F": 6
        } as any;
        let str = GlobalObject.getInstance().main.stageName || "Z"
        let letter = str.substring(0, 1) as any;
        if (obj[letter]){
            let data = obj[letter];
            this.onWorkshopChanged(data);
        }
    }

    public reload() {
        this.spotLight?.setEnabled(true);
        this.groundMesh?.setEnabled(true);
        //this.equipmentMesh?.setEnabled(true);
        if (this.equipmentMesh) {


        }
        this.init();
    }
    public unload() {
        this.spotLight?.setEnabled(false);
        this.groundMesh?.setEnabled(false);
        this.menu.changeBackBtn(false);
        //this.equipmentMesh?.setEnabled(false);
        if (this.equipmentMesh) {
            (this.equipmentMesh as TransformNode).getChildMeshes().forEach((c) => {
                this.shadowGenerator?.removeShadowCaster(c);
                c.receiveShadows = false;
            });
            this.equipmentMesh.dispose();
            this.equipmentMesh = null;
        }
    }
}